const trainingStructureText =
  '1. Bemelegítés\nAz edzéseket mindig közös bemelegítéssel kezdjük. Ez nem csak arról szól, hogy felkészítsük a testet a mozgásra – ilyenkor érkezünk meg fejben is az edzésre, és a csapat is összerázódik.\n\n2. Erőnléti edzés\nEzután következik az erőnléti blokk, ahol olyan gyakorlatokkal dolgozunk, amelyek fejlesztik a koordinációt, állóképességet és dinamikusabb mozgást adnak a pályán. A cél itt nem feltétlenül az, hogy elfáradj – hanem hogy jobb játékos legyél. De a legtöbb esetben azért el fogsz fáradni. :)\n\n3. Ütős gyakorlatok\nEzután jön a labdás rész. Sok közös gyakorlásra és meccshelyzetre építünk, hogy ne csak gyakorold a mozdulatokat, hanem játék közben is tudd használni őket. A csapatedzésnek nem fókusza a technika javítása az edzés jellegéből adódóan, azonban amennyire az idő engedi, igyekszem tippeket adni. Egy pályán egyszerre legfeljebb három fő dolgozik, így mindenkinek jut elég tér és lehetőség. A pályák számát mindig az aktuális létszámhoz igazítjuk.\n\n4. Játék\nAz edzés végén pedig jöhet a játék: mindenki játszik egy szettet, utána partnercsere – így több emberrel találkozol, több stílus ellen játszol, és közben a közösség is épül.';

const legacyTrainingFlowTexts = new Set([
  'Bemelegítés és mobilizáció (15 perc)\nTechnikai gyakorlatok párban (30 perc)\nTaktikai feladatok és szituációs játékok (30 perc)\nMeccsek és versenyhelyzetek (30 perc)\nNyújtás és lazítás (15 perc)',
  'Bemelegítés\nErőnléti edzés\nÜtős gyakorlatok\nJáték',
]);

const normalizeMultilineText = (value) => (typeof value === 'string' ? value.replace(/\r\n/g, '\n').trim() : '');

export const defaultBillingInfoText =
  'A megadott számlázási adatokat a szolgáltatás teljesítéséhez és a számla kiállításához használjuk fel. A számla kiállítása a Billingo online számlázó rendszerén keresztül történik.';

const defaultPrivacyPolicyText =
  `## Adatkezelési tájékoztató

Ez a tájékoztató összefoglalja, hogy a PNG Squash weboldal, a felhasználói fiók, a vasárnapi csapatedzésekre történő jelentkezés, a várólista, a profiloldal, az eredmények, az értesítések, a várólistás helyfelajánlások és a számlázási adminisztráció során milyen személyes adatokat kezelek, milyen célból, milyen jogalapon, meddig, és milyen jogaid vannak az adatkezeléssel kapcsolatban.

## Adatkezelő

Az adatkezelő adatai az Impresszum oldalon találhatók. Adatkezelési kérdéssel, adatmódosítási vagy törlési kéréssel a láblécben és az Impresszumban megadott e-mail címen tudsz kapcsolatba lépni velem.

## Kezelt adatok köre

A weboldalon Google fiókkal vagy e-mail címmel és jelszóval lehet regisztrálni és belépni. A belépés során a rendszer a választott hitelesítési módhoz kapcsolódó felhasználói azonosítót, e-mail címet, megjelenített nevet, Google fiók esetén profilképet, a belépési szolgáltató azonosítóját, az e-mail megerősítési állapotát, a fiók létrehozásának és utolsó belépésének időpontját, valamint a kapcsolódó technikai azonosítókat kezeli.

E-mailes regisztráció esetén az e-mail címet kisbetűsített, egységes formában használja a rendszer. A jelszót a Firebase Authentication kezeli; a weboldal nyers jelszót nem tárol, és azt az admin felületen sem lehet megtekinteni. A jelszóra az oldal erősségi szabályokat alkalmaz, például legalább 10 karaktert, kisbetűt, nagybetűt és számot vár el. E-mailes regisztrációnál a rendszer megerősítő e-mailt küld, és a belépést csak megerősített e-mail címmel engedi. Jelszó-visszaállítás esetén a Firebase Authentication jelszó-visszaállító e-mailt küld.

A felhasználói fiókhoz a Firestore users kollekcióban kapcsolódhatnak alapadatok: felhasználói azonosító, e-mail cím, megjelenített név, profilkép URL, belépési szolgáltató azonosítói, e-mail megerősítési állapot, létrehozási és frissítési időpont, utolsó belépés időpontja, adminisztratív tiltás vagy jogosultsági jelölés, valamint a számlázáshoz, értesítésekhez és edzésadminisztrációhoz szükséges beállítások.

Jelentkezéskor kezelem az edzés dátumát, időpontját, a jelentkezés időpontját, a felhasználó azonosítóját, nevét, e-mail címét, becenevét, a jelentkezési státuszt, a várólistás státuszt, valamint azt, hogy az adott alkalomra jelentkezett-e, várólistára került-e vagy lemondta-e a részvételt. Várólista esetén rögzülhet a várólistás pozíció, a helyfelajánlás kiküldésének ideje, a visszajelzési határidő, a visszajelzés állapota, valamint a visszajelző linkhez kapcsolódó technikai azonosító. Késői lemondás esetén a lemondás ténye, időpontja és a kapcsolódó díjszámítás is rögzülhet.

A profiloldalon megadható vagy módosítható a becenév. A becenév egy külön nicknames nyilvántartásban is szerepelhet azért, hogy egy becenév egyszerre csak egy felhasználóhoz tartozzon. A becenév edzéshez, eredményekhez, ranglistához vagy közösségi megjelenítéshez kapcsolódhat.

Ha a felhasználó eredményt rögzít vagy az admin eredményt rögzít hozzá, kezelem az edzés dátumát, a gyakorlat nevét és azonosítóját, az eredmény értékét, mértékegységét, a rögzítés időpontját, a rögzítő felhasználó azonosítóját, valamint a felhasználó nevét, e-mail címét vagy becenevét. Ezek az adatok személyes rekordokhoz és ranglistákhoz is felhasználhatók.

Számlázáshoz a számla kiállításához szükséges adatokat kérem be és tárolom, például név, számlázási cím, ország, irányítószám, város, utca és házszám. A weboldal nem kér bankkártyaadatot, és közvetlen online fizetés jelenleg nincs.

A számlázási adminisztrációhoz kezelhető a fizetési mód, a számlázási mód, az edzés díja, a késői lemondás díja, a számlázási státusz, az egyenleg, az egyenlegmozgás, a számlázási előkészítés és a számlázási futtatás adatai. Ezek az adatok azt szolgálják, hogy az edzések után a számlázás ellenőrizhetően és pontosan történjen.

Az értesítési beállítások között kezelhető, hogy milyen operatív e-maileket kérsz vagy engedélyezel. Ide tartozhatnak például jelentkezési, várólistás, edzéslemondási, számlázási vagy egyéb, az edzés szervezéséhez kapcsolódó értesítések. Marketing célú hírlevél küldése jelenleg nem része a weboldal működésének.

A rendszer operatív e-mail küldési naplókat is kezelhet. Ilyen adat lehet például az e-mail típusa, címzettje, az edzés dátuma, a küldés időpontja, a küldési szolgáltató által visszaadott e-mail azonosító, valamint az, hogy az adott értesítés elküldése sikeres volt-e. Ezek az adatok az értesítések igazolhatóságát és a hibakeresést szolgálják.

Egészségügyi vagy más különleges adatot a weboldal nem kér. Ha ilyen információt önkéntesen közölsz velem, azt kizárólag az edzéssel kapcsolatos egyeztetés, a biztonságos részvétel és az adott helyzet kezelése érdekében veszem figyelembe.

## Az adatkezelés célja

Az adatkezelés célja a felhasználói fiók létrehozása és működtetése, a bejelentkezés biztosítása, az e-mail cím megerősítése, a jelszó-visszaállítás lehetővé tétele, az edzésekre történő jelentkezések és várólisták kezelése, a helyek nyilvántartása, a várólistás helyfelajánlások kezelése, a részvételi és lemondási szabályok nyomon követése, az eredmények és ranglisták kezelése, az értesítések küldése és igazolhatósága, a kapcsolattartás, valamint a számlázási, adózási és jogszabályi kötelezettségek teljesítése.

## Az adatkezelés jogalapja

A fiók létrehozásához, a Google belépéshez, az e-mailes regisztrációhoz, az e-mail megerősítéshez, a jelszó-visszaállításhoz és a belépéshez kapcsolódó adatkezelés a felhasználó önkéntes döntésén, valamint a szolgáltatás igénybevételéhez szükséges technikai működésen alapul.

Az edzésre jelentkezéshez kapcsolódó adatkezelés a jelentkezéssel létrejövő szolgáltatási jogviszony teljesítéséhez szükséges. A jelentkezés fizetési kötelezettséggel járhat a Szolgáltatási feltételekben leírtak szerint.

A számlázási adatok kezelése jogi kötelezettség teljesítéséhez szükséges. A lemondásokkal, várólistával, fizetési státusszal, egyenleggel, eredményekkel, adminisztratív beállításokkal és esetleges vitás helyzetekkel kapcsolatos adatok kezelése jogos érdek alapján is történhet, például a jelentkezési, lemondási, fizetési és részvételi szabályok igazolhatósága, az edzések szervezése és a visszaélések megelőzése érdekében.

Az értesítési beállítások kezelése és az operatív értesítések küldése a szolgáltatás teljesítéséhez, illetve jogos érdekhez kapcsolódik. Amennyiben a jövőben marketing célú üzenetküldés indulna, az külön tájékoztatás és szükség esetén külön hozzájárulás alapján történne.

## Számlázás

A számla kiállítása Billingo online számlázó rendszer használatával történik vagy történhet automatikusan. A Billingo a számlázáshoz szükséges adatok tekintetében adatfeldolgozóként működik. A számlázási adatok kezelése a számla létrehozása, továbbítása és a jogszabályi megőrzési kötelezettségek teljesítése céljából történik.

## Adatfeldolgozók és szolgáltatók

A weboldal Firebase szolgáltatásokat használhat hitelesítésre, adatbázisra, felhőfunkciókra és tárhelyre. A Google belépéshez Google/Firebase szolgáltatás, az e-mailes regisztrációhoz, e-mail megerősítéshez, jelszókezeléshez és jelszó-visszaállításhoz Firebase Authentication kapcsolódik. Az adatok tárolása Firestore adatbázisban történhet. Az operatív e-mailek küldéséhez Resend e-mail szolgáltatás kerül felhasználásra. A számlázáshoz Billingo online számlázó szolgáltatás kerül felhasználásra. A tárhelyszolgáltató adatai az Impresszumban szerepelnek.

Ezek a szolgáltatók a weboldal működtetéséhez, az azonosításhoz, az e-mailes fiókmegerősítéshez, a jelszó-visszaállításhoz, az adatok tárolásához, az operatív értesítések és várólistás helyfelajánlások küldéséhez, a számlázáshoz vagy a kapcsolattartáshoz szükséges technikai feladatokat látják el.

Egyes szolgáltatók nemzetközi háttérrel működnek, ezért előfordulhat, hogy az adatkezeléshez kapcsolódó technikai műveletek az Európai Gazdasági Térségen kívüli adatfeldolgozást vagy adattovábbítást is érintenek. Ilyen esetben a szolgáltatók saját adatvédelmi feltételei és a vonatkozó garanciák irányadók.

## Adatbiztonság

Az adatok védelme érdekében a weboldal és a használt szolgáltatások technikai és szervezési biztonsági intézkedéseket alkalmaznak. Az admin felülethez csak jogosult felhasználó férhet hozzá. A jelszavakat nem a weboldal tárolja olvasható formában. A cél az, hogy a személyes adatokhoz illetéktelen személy ne férjen hozzá, azok ne vesszenek el, ne módosuljanak jogosulatlanul, és ne kerüljenek indokolatlanul továbbításra.

## Megőrzési idő

A felhasználói fiókhoz, bejelentkezéshez, jelentkezésekhez, várólistához, értesítésekhez, becenévhez és eredményekhez kapcsolódó adatokat addig kezelem, amíg az szükséges az edzések szervezéséhez, a fiók működtetéséhez, a kapcsolattartáshoz, a lemondások kezeléséhez, a vitás helyzetek rendezéséhez vagy jogszabályi kötelezettség teljesítéséhez.

Ha kéred a fiókod törlését, a fiókhoz kapcsolódó, további kezeléshez nem szükséges adatokat törlöm vagy anonimizálom. Bizonyos adatokat - például számlázási adatokat, számviteli bizonylatokat, vagy vitás helyzet igazolásához szükséges adatokat - jogszabályi kötelezettség vagy jogos érdek alapján a fiók törlése után is meg kell őrizni.

A számlázási és könyvviteli bizonylatokhoz kapcsolódó adatokat a vonatkozó számviteli és adózási szabályok szerinti ideig, jellemzően 8 évig kell megőrizni.

## Érintetti jogok

Kérheted a rád vonatkozó személyes adatokhoz való hozzáférést, azok helyesbítését, törlését, kezelésük korlátozását, valamint tiltakozhatsz az adatkezelés ellen, ha annak jogalapja jogos érdek. Ha az adatkezelés hozzájáruláson alapul, a hozzájárulást bármikor visszavonhatod.

A profiloldalon bizonyos adatokat közvetlenül is módosíthatsz, például a számlázási címet, a becenevet és az értesítési beállításokat. Az e-mail címet és a jelszót a hitelesítési szolgáltatás kezeli; jelszó-visszaállítást a belépési felületen tudsz kérni.

A kérelmeket indokolatlan késedelem nélkül, legfeljebb egy hónapon belül válaszolom meg. Szükség esetén, a kérelem összetettségétől függően ez a határidő jogszabály szerint meghosszabbítható.

## Panasz és jogorvoslat

Adatkezelési kérdés vagy panasz esetén elsőként kérlek, írj a kapcsolati e-mail címre, hogy a kérést közvetlenül kezelni tudjam.

Jogorvoslati lehetőséggel a Nemzeti Adatvédelmi és Információszabadság Hatóságnál is élhetsz.

Nemzeti Adatvédelmi és Információszabadság Hatóság
Cím: 1055 Budapest, Falk Miksa utca 9-11.
Levelezési cím: 1363 Budapest, Pf. 9.
E-mail: ugyfelszolgalat@naih.hu
Telefon: +36 (30) 683-5969, +36 (30) 549-6838, +36 (1) 391 1400
Honlap: https://www.naih.hu

## Módosítás

Az adatkezelési tájékoztató időről időre frissülhet, különösen akkor, ha a weboldal működése, a használt szolgáltatók köre vagy a számlázási folyamat változik. A weboldalon mindig az aktuális változat érhető el.`;

const defaultCookiePolicyText =
  `## Cookie tájékoztató

A weboldal jelenleg nem használ marketing célú sütiket, hirdetési pixeleket vagy remarketing követőkódokat.

## Mik azok a sütik és hasonló technológiák?

A sütik kis adatfájlok, amelyeket a böngésző tárolhat az oldal használata közben. A weboldal emellett hasonló böngészőoldali tárolást is használhat, például localStorage-t. Ezek segíthetnek az oldal működésében, a bejelentkezés fenntartásában, a biztonságos munkamenet kezelésében, a téma beállítás megjegyzésében vagy a cookie tájékoztató elfogadásának rögzítésében.

## Feltétlenül szükséges sütik

A működéshez szükséges technikai sütik és hasonló technológiák előfordulhatnak, például a bejelentkezés, a biztonságos munkamenet, a Google/Firebase hitelesítés, az e-mailes fiók használata, a jelentkezés, a profil használata és a cookie beállítások megjegyzése érdekében. Ezek nélkül a fiókhoz kötött funkciók nem működnének megfelelően.

## Helyi böngészőtár

A weboldal a böngésző helyi tárában eltárolhatja például a választott megjelenési módot és azt, hogy a cookie tájékoztatót már elfogadtad. Ez nem marketing célú követés, hanem kényelmi és működési beállítás.

## Analitikai és marketing sütik

Az oldal jelenlegi működése alapján nincs külön analitikai vagy marketing célú mérés. Ezért a cookie bannernek elegendő röviden jeleznie, hogy az oldal technikai sütiket használ, és nincs marketing célú követés.

Ha a jövőben Google Analytics, Google Tag Manager, Facebook pixel vagy más statisztikai, marketing vagy remarketing eszköz kerül az oldalra, ezek csak a tájékoztató frissítése és szükség esetén előzetes hozzájárulás után működhetnek.

## Harmadik fél szolgáltatásai

A Google belépés és a Firebase szolgáltatások használata során a Google saját technikai sütiket vagy hasonló azonosítókat alkalmazhat. Ezek célja a hitelesítés, a biztonságos működés, az e-mailes fiókmegerősítés és a szolgáltatás technikai biztosítása.

## Cookie beállítások kezelése

A sütiket a böngésző beállításaiban bármikor törölheted vagy blokkolhatod. Fontos, hogy a szükséges sütik tiltása esetén a belépés, a jelentkezés vagy a profil oldal egyes funkciói nem biztos, hogy megfelelően működnek.

## Cookie banner

A weboldalon rövid cookie banner jelenhet meg. Ennek célja, hogy jelezze a technikai sütik és hasonló böngészőoldali tárolás használatát, valamint linket adjon ehhez a tájékoztatóhoz. A banner elfogadásának ténye a böngésző helyi tárában rögzül, hogy a tájékoztató ne jelenjen meg minden látogatáskor újra. Mivel jelenleg nincs marketing célú követés, nincs szükség külön marketing hozzájárulásra.`;

const defaultImprintText =
  '## Impresszum\n\n## Üzemeltető\n\nNév: PNG Squash\nCím / székhely: szerkesztés alatt\nAdószám / nyilvántartási szám: szerkesztés alatt\nE-mail: szerkesztés alatt\nTelefon: szerkesztés alatt\n\n## Tárhelyszolgáltató\n\nA tárhelyszolgáltató adatai szerkesztés alatt.\n\n## Kapcsolat\n\nKérdés esetén a láblécben megadott e-mail címen vagy telefonszámon tudsz kapcsolatba lépni velem.';

const defaultTermsText =
  `## Szolgáltatási feltételek

A PNG Squash weboldalon keresztül vasárnapi squash csapatedzésekre lehet jelentkezni. A normál jelentkezés elküldése és visszaigazolása részvételi és fizetési kötelezettséggel járhat a jelen feltételek szerint.

## Felhasználói fiók

Jelentkezni bejelentkezés után lehet. A weboldalon Google fiókkal vagy e-mail címmel és jelszóval lehet belépni. E-mailes regisztráció esetén a belépéshez az e-mail cím megerősítése szükséges. A résztvevő felel azért, hogy a profilban és a számlázási adatoknál valós, pontos adatokat adjon meg.

## Jelentkezés

Az edzésen való részvétel előzetes jelentkezéshez kötött. Jelentkezni a weboldalon lehet, az adott alkalomnál megjelenő jelentkezési határidőig. A jelenlegi alapműködés szerint a jelentkezési határidő az edzést megelőző nap 21:00.

A jelentkezés során a résztvevő kiválasztja az edzés dátumát, és a rendszer rögzíti a helyfoglalást. A normál helyfoglalás a visszaigazoló e-mail megérkezésével válik véglegessé. A jelentkezés elküldésével a résztvevő elfogadja, hogy a részvétel és a lemondás szabályai fizetési kötelezettséget eredményezhetnek.

Az edzések létszáma korlátozott. Ha az adott alkalom betelt, a weboldal várólistás jelentkezést kínálhat fel.

## Várólista

A várólistára kerülés önmagában még nem végleges részvétel, és nem jelent normál részvételi díjra vonatkozó fizetési kötelezettséget. Ha felszabadul egy hely, a rendszer e-mailben helyfelajánlást küldhet a várólistán szereplő résztvevőnek.

A helyfelajánlásra a kiküldéstől számított 2 órán belül lehet válaszolni. Ha a résztvevő elfogadja a helyet, átkerül a normál jelentkezők közé, és ettől kezdve ugyanazok a részvételi, lemondási és fizetési szabályok vonatkoznak rá, mint a többi jelentkezőre. Ha a résztvevő elutasítja a helyet vagy nem válaszol határidőben, a lehetőség továbbadható más várólistás résztvevőnek.

## Fizetés és számlázás

Az oldalon közvetlen online fizetés és bankkártyás fizetés jelenleg nincs. Az edzésekhez kapcsolódó díjak számlázása az edzések után történik.

A számlázás Billingo online számlázó rendszer használatával automatikusan is történhet, ezért a jelentkezéshez vagy a profilhoz kapcsolódó számlázási adatok megadása szükséges lehet. A számla a megadott számlázási adatok alapján kerül kiállításra.

A fizetendő összeg az adott edzéshez tartozó díj, a tényleges részvételi vagy lemondási státusz, valamint az admin felületen rögzített számlázási beállítások alapján kerül előkészítésre. Az adminisztráció kezelhet egyenleget, jóváírást vagy korábbi befizetést is; ha az egyenleg fedezi az adott díjat, a rendszer azt levonhatja, és külön számla kiállítása nem feltétlenül szükséges. Átutalásos fizetés esetén a fizetési határidő a számlán vagy az adminisztrációban megadott határidő szerint alakul.

## Lemondás

A részvétel díjmentesen lemondható az edzést megelőző nap 15:00-ig.

Az edzést megelőző nap 15:00 utáni lemondás késői lemondásnak minősül. Ilyenkor a teljes díj 70%-a kerülhet kiszámlázásra, mivel ilyen rövid határidővel a felszabaduló helyet általában már nem lehet más résztvevőnek felajánlani.

Lemondás nélküli meg nem jelenés esetén a teljes díj kerül kiszámlázásra.

## Szervezői lemondás és adminisztratív módosítás

Ha az edzés szervezői okból elmarad, az adott alkalomra leadott jelentkezés nem jár fizetési kötelezettséggel. Ilyen esetben a résztvevőket a megadott elérhetőségeken keresztül tájékoztatom.

Indokolt esetben a jelentkezés vagy várólistás hely adminisztratív okból törölhető, például szervezési ok, téves jelentkezés, szabályszegés, fizetési probléma vagy visszaélés gyanúja miatt. Súlyos vagy ismétlődő esetben a jelentkezési lehetőség admin által korlátozható.

## Részvétel és felelősség

Az edzésen minden résztvevő saját felelősségére vesz részt. Kérlek, csak egészségi állapotodnak megfelelően jelentkezz és vegyél részt az edzésen. Betegség, sérülés vagy olyan állapot esetén, amely a sportolást befolyásolhatja, kérlek jelezd előre, és szükség esetén kérj orvosi tanácsot.

A résztvevő köteles az edzés helyszínének házirendjét, a biztonsági szabályokat és az edző utasításait betartani.

## Kapcsolattartás

Jelentkezéssel, lemondással, számlázással vagy egyéb kérdéssel kapcsolatban a láblécben és az Impresszumban megadott elérhetőségeken tudsz kapcsolatba lépni velem.

## Módosítás

A szolgáltatási feltételek időről időre frissülhetnek. A weboldalon mindig az aktuális változat érhető el.`;

const isLegacyTrainingFlowText = (value) => {
  const normalized = normalizeMultilineText(value);
  if (legacyTrainingFlowTexts.has(normalized)) {
    return true;
  }

  const lines = normalized.split('\n').map((line) => line.trim()).filter(Boolean);
  return lines.length > 1 && lines.length <= 6 && lines.every((line) => line.length <= 80);
};

export const defaultSiteContent = {
  heroTitleLine1: 'Vasárnapi',
  heroTitleHighlight: 'Csapatedzés',
  heroSubtitle: 'Csatlakozz hozzánk minden vasárnap 9:00–11:00 között egy energikus squash edzésre!',
  heroBackgroundUrl: '',
  heroBackgroundUrls: [],
  heroBackgroundPositions: [],
  aboutTitle: 'Rólam',
  aboutParagraph1:
    'Szenvedélyes squash edző vagyok, több mint egy évtizedes tapasztalattal. Célom, hogy minden szintű játékost segítsek fejlődni – legyen szó kezdőkről vagy haladókról. Az edzéseim során a technika, a taktika és az állóképesség egyaránt kiemelt szerepet kap.',
  aboutParagraph2:
    'Hiszem, hogy a squash nemcsak sport, hanem egy közösség is. A vasárnapi csapatedzések remek lehetőséget nyújtanak arra, hogy új embereket ismerj meg, miközben fejleszted a játékodat.',
  aboutProfileImageUrl: '',
  aboutProfileImagePosition: '50% 50%',
  aboutBackgroundUrl: '',
  aboutBackgroundPosition: '50% 50%',
  trainingTitle: 'Csapatedzés',
  trainingSubtitle: 'Strukturált edzés, amelyben a bemelegítéstől a meccsszituációkig mindent lefedünk.',
  trainingBackgroundUrl: '',
  trainingBackgroundPosition: '50% 50%',
  trainingPrice: 'Dinamikus árazás 7 500 Ft-tól',
  trainingPlanTitle: 'Felépítés',
  trainingFlowSteps: trainingStructureText,
  pricingTitle: 'Árazás',
  pricingSubtitle: 'Válaszd ki a számodra legmegfelelőbb csomagot.',
  pricingBand1: 'Egy alkalom: 3.000 Ft / fő',
  pricingBand2: '4 alkalmas bérlet: 11.000 Ft / fő',
  pricingBand3: '8 alkalmas bérlet: 20.000 Ft / fő',
  pricingBand4: 'Próbaedzés: 2.500 Ft / fő',
  registerTitle: 'Jelentkezés',
  registerSubtitle: 'Válaszd ki a dátumot és foglald le a helyed!',
  registerRules:
    'A részvétel előzetes jelentkezéshez kötött. Jelentkezni itt, a honlapon tudsz, legkésőbb az edzés napját megelőző napon 21:00-ig.\nA részvétel lemondása az edzést megelőző nap 15:00-ig lehetséges díjmentesen.\nAz edzést megelőző nap 15:00 utáni lemondás esetén a teljes díj 70%-a kerül kiszámlázásra, mivel ilyen rövid idő alatt a felszabaduló helyet általában már nem tudom másnak felajánlani.\nLemondás nélküli meg nem jelenés esetén a teljes díj kerül kiszámlázásra.\nA helyfoglalás a visszaigazoló e-mail megérkezésével válik véglegessé.',
  billingInfoText: defaultBillingInfoText,
  contactEmail: '',
  contactPhone: '',
  privacyPolicyTitle: 'Adatkezelési tájékoztató',
  privacyPolicyText: defaultPrivacyPolicyText,
  cookiePolicyTitle: 'Cookie tájékoztató',
  cookiePolicyText: defaultCookiePolicyText,
  imprintTitle: 'Impresszum',
  imprintText: defaultImprintText,
  termsTitle: 'Szolgáltatási feltételek',
  termsText: defaultTermsText,
  footerText: '© 2026 PNG Squash. Minden jog fenntartva.',
};

export const siteContentFields = [
  { key: 'heroTitleLine1', label: 'Hero címsor (1. sor)' },
  { key: 'heroTitleHighlight', label: 'Hero címsor (kiemelt rész)' },
  { key: 'heroSubtitle', label: 'Hero alcím', multiline: true },
  { key: 'aboutTitle', label: 'Rólam szekció címe' },
  { key: 'aboutParagraph1', label: 'Rólam 1. bekezdés', multiline: true },
  { key: 'aboutParagraph2', label: 'Rólam 2. bekezdés', multiline: true },
  { key: 'trainingTitle', label: 'Csapatedzés szekció címe' },
  { key: 'trainingSubtitle', label: 'Csapatedzés alcím', multiline: true },
  { key: 'trainingPrice', label: 'Ár (edzésenként)' },
  { key: 'trainingPlanTitle', label: 'Felépítés blokk címe' },
  { key: 'trainingFlowSteps', label: 'Felépítés szöveg (1. Cím + leírás)', multiline: true },
  { key: 'pricingTitle', label: 'Árazás szekció címe' },
  { key: 'pricingSubtitle', label: 'Árazás alcím', multiline: true },
  { key: 'pricingBand1', label: 'Árazás 1. sáv' },
  { key: 'pricingBand2', label: 'Árazás 2. sáv' },
  { key: 'pricingBand3', label: 'Árazás 3. sáv' },
  { key: 'pricingBand4', label: 'Árazás 4. sáv' },
  { key: 'registerTitle', label: 'Jelentkezés szekció címe' },
  { key: 'registerSubtitle', label: 'Jelentkezés alcím', multiline: true },
  { key: 'registerRules', label: 'Jelentkezési szabályok (soronként 1 pont)', multiline: true },
  { key: 'billingInfoText', label: 'Számlázási adatok tájékoztató szöveg', multiline: true },
  { key: 'footerText', label: 'Lábléc szöveg' },
];

export const administrationContentSections = [
  {
    title: 'Kapcsolat',
    description: 'A láblécben megjelenő telefonszám és e-mail cím. Az e-mail kattintható levélküldő linkként jelenik meg.',
    fields: [
      { key: 'contactEmail', label: 'Kapcsolati e-mail cím' },
      { key: 'contactPhone', label: 'Telefonszám' },
    ],
  },
  {
    title: 'Adatkezelési tájékoztató',
    description: 'A regisztrációhoz, jelentkezéshez, számlázáshoz és admin működéshez kapcsolódó adatkezelési szöveg.',
    fields: [
      { key: 'privacyPolicyTitle', label: 'Oldal címe' },
      { key: 'privacyPolicyText', label: 'Adatkezelési tájékoztató szövege', multiline: true, rows: 16 },
    ],
  },
  {
    title: 'Cookie tájékoztató',
    description: 'Rövid tájékoztató a technikai sütikről és arról, hogy nincs marketing célú követés.',
    fields: [
      { key: 'cookiePolicyTitle', label: 'Oldal címe' },
      { key: 'cookiePolicyText', label: 'Cookie tájékoztató szövege', multiline: true, rows: 8 },
    ],
  },
  {
    title: 'Impresszum',
    description: 'Üzemeltetői és tárhelyszolgáltatói adatok. Ezeket érdemes pontosan kitölteni publikálás előtt.',
    fields: [
      { key: 'imprintTitle', label: 'Oldal címe' },
      { key: 'imprintText', label: 'Impresszum szövege', multiline: true, rows: 10 },
    ],
  },
  {
    title: 'Szolgáltatási feltételek',
    description: 'Jelentkezési kötelezettség, számlázás, Billingo, lemondási és fizetési szabályok.',
    fields: [
      { key: 'termsTitle', label: 'Oldal címe' },
      { key: 'termsText', label: 'Szolgáltatási feltételek szövege', multiline: true, rows: 12 },
    ],
  },
];

export const pickSiteContent = (source = {}) => {
  const picked = {};
  Object.keys(defaultSiteContent).forEach((key) => {
    if (typeof source[key] === 'string') {
      picked[key] = source[key];
    }
    if (Array.isArray(defaultSiteContent[key]) && Array.isArray(source[key])) {
      picked[key] = source[key].filter((item) => typeof item === 'string' && item.trim());
    }
  });

  if (['Az edzés menete', 'Struktúra', 'A csapatedzés leírása'].includes(picked.trainingPlanTitle)) {
    picked.trainingPlanTitle = defaultSiteContent.trainingPlanTitle;
  }

  if (isLegacyTrainingFlowText(picked.trainingFlowSteps)) {
    picked.trainingFlowSteps = defaultSiteContent.trainingFlowSteps;
  }

  if (['3.000 Ft / alkalom', 'Dinamikus árazás'].includes(picked.trainingPrice)) {
    picked.trainingPrice = defaultSiteContent.trainingPrice;
  }

  return picked;
};
